var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateOrderDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 3.66827C16.6604 3.67937 17.7402 3.76779 18.4445 4.47214C19.25 5.27759 19.25 6.57396 19.25 9.16668V14.6667C19.25 17.2594 19.25 18.5558 18.4445 19.3612C17.6391 20.1667 16.3427 20.1667 13.75 20.1667H8.25C5.65728 20.1667 4.36091 20.1667 3.55546 19.3612C2.75 18.5558 2.75 17.2594 2.75 14.6667V9.16668C2.75 6.57396 2.75 5.27759 3.55546 4.47214C4.25981 3.76779 5.33956 3.67937 7.33333 3.66827",
    stroke: "#68D3C1",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.625 12.8333L15.5833 12.8333",
    stroke: "#68D3C1",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.41666 12.8333H6.875",
    stroke: "#68D3C1",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.41666 9.625H6.875",
    stroke: "#68D3C1",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.41666 16.0417H6.875",
    stroke: "#68D3C1",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.625 9.625H15.5833",
    stroke: "#68D3C1",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.625 16.0417H15.5833",
    stroke: "#68D3C1",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33334 3.20831C7.33334 2.44892 7.94894 1.83331 8.70834 1.83331H13.2917C14.0511 1.83331 14.6667 2.44892 14.6667 3.20831V4.12498C14.6667 4.88437 14.0511 5.49998 13.2917 5.49998H8.70834C7.94894 5.49998 7.33334 4.88437 7.33334 4.12498V3.20831Z",
    stroke: "#68D3C1",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateOrderDark);
export default __webpack_public_path__ + "static/media/create-order-dark.76a129a7fcdeb1e3575b5a46a05bce0e.svg";
export { ForwardRef as ReactComponent };